import { Typography } from '@mui/material';

interface IProps {
	text: string;
}

export default function Label({ text }: IProps) {
	return <Typography className={'min-w-28 rounded bg-primary-opacity py-1.5 text-center text-sm md:w-40'}>{text}</Typography>;
}
